import { MenuItem } from '@/services/MenuItem';
import { SidebarHeaderItem } from 'vue-sidebar-menu';

export class MenuGroup implements SidebarHeaderItem {
    constructor(title: string, icon: string | object, child: Array<MenuItem | MenuGroup> = [], header: boolean = false) {
        this.title = title;
        this.icon = icon ;
        this.child = child;
        this.header = header;
        this.Active = false;
    };
    
    public title: string;
    public icon: string | object;
    public child: Array<MenuItem | MenuGroup>;
    public header: boolean = false;
    public Active: boolean;

}